{
  "alert.informative": "Informativo",
  "alert.negative": "Negativo",
  "alert.notice": "Avviso",
  "alert.positive": "Positivo",
  "attachmentlist.nextAttachments": "Mostra allegati successivi",
  "attachmentlist.previousAttachments": "Mostra allegati precedenti",
  "chat.newMessage": "Nuovo messaggio",
  "chat.scrollToBottom": "Scorri alla fine",
  "messagefeedback.thumbDown": "Risposta scadente",
  "messagefeedback.thumbUp": "Risposta buona",
  "promptfield.aiDisclaimer": "Le risposte sono generate dall’IA e potrebbero essere imprecise. Verificale prima di utilizzarle.",
  "promptfield.aiUserGuidlines": "Linee guida per l’utente di IA",
  "promptfield.attachments": "Allegati",
  "promptfield.insertButton": "Aggiungi",
  "promptfield.label": "Prompt",
  "promptfield.placeholder": "Iniziamo? Fai una domanda, condividi un’idea o aggiungi un’attività.",
  "promptfield.placeholder.small": "Chiedi qualsiasi cosa",
  "promptfield.stopButton": "Interrompi",
  "promptfield.submitButton": "Invia",
  "promptfield.uploading": "Caricamento",
  "responsestatus.loading": "Caricamento",
  "responsestatus.processing": "Elaborazione in corso...",
  "voicebutton.startListening": "Avvia registrazione",
  "voicebutton.stopListening": "Interrompi registrazione"
}
